import i18n from '@/plugins/i18n'

export default {
  data () {
    return {
      dialogSettings: {
        okText: i18n.t('common.ok'),
        cancelText: i18n.t('common.back'),
        animation: 'bounce',
        backdropClose: false
      }
    }
  },
  methods: {
    showError (err, showErrMsg = false, customMessage = null) {
      // console.error(err)
      const message = {
        title: i18n.t('error.generalError'),
        body: showErrMsg ? err.message : customMessage || '-- ' + i18n.t('error.generalError') + ' --'
      }

      this.$dialog.confirm(message, this.dialogSettings)
        .then((dialog) => {})
    }
  }
}
